import {GroupToursRFQFormData, PostalAddress} from './definitions';

const POSTAL_ADDRESS: PostalAddress = {
	streetAddress: null,
	postalCode: null,
	addressLocality: null,
	addressCountry: null,
	contactType: null,
};

const DEFAULT_PROPS: GroupToursRFQFormData = {
	customer: {
		honorificPrefix: null,
		salutation: null,
		givenName: null,
		familyName: null,
		address: POSTAL_ADDRESS,
		email: null,
		telephone: null,
	},
	participant: {
		name: null,
		additionalType: null,
		address: POSTAL_ADDRESS
	},
	quoteRequest: {
		groupedTrips: [],
		offerPrice: null,
		offerIncludesAccommodation: [],
		offerIncludesTransportation: [],
		offerIncludesParticipants: {
			totalAmountOfParticipants: null,
			amountOfParticipantsInSingleRooms: null,
			amountOfParticipantsInDoubleRooms: null,
			amountOfParticipantsInMultiBedRooms: null
		},
		arrivalTime: null,
		departureTime: null,
		departureStation: null,
		departureAirport: null,
		departureBusStation: null,
		duration: null,
		timeFlexibility: null,
		alternativeArrivalTime: null,
		alternativeDepartureTime: null,
		alternativeDuration: null,
		alternativeTimeFlexibility: null,
	},
	newsletter: false,
	referer: null,
	description: null,
};

export default DEFAULT_PROPS;
